import {defineMessages} from 'react-intl'

export const messages = defineMessages({
  productTitle: {
    id: 'product',
    defaultMessage: 'Product'
  },
  companyTitle: {
    id: 'company',
    defaultMessage: 'Company'
  },
  contactTitle: {
    id: 'contact',
    defaultMessage: 'Contact'
  },
  affiliateProgram: {
    id: 'affiliateProgram',
    defaultMessage: 'Affiliate program'
  },
  cookiePreferences: {
    id: 'cookiePreferences',
    defaultMessage: 'Cookie preferences'
  },
  cookiePolicy: {
    id: 'cookiePolicy',
    defaultMessage: 'Cookie policy'
  },
  privacy: {
    id: 'privacyPolicy',
    defaultMessage: 'Privacy policy'
  },
  terms: {
    id: 'termsOfUse',
    defaultMessage: 'Terms of use'
  },
  aboutUs: {
    id: 'aboutUs',
    defaultMessage: 'About us'
  },
  blog: {
    id: 'blog',
    defaultMessage: 'Blog'
  },
  careers: {
    id: 'careers',
    defaultMessage: 'Careers'
  },
  getHelp: {
    id: 'getHelp',
    defaultMessage: 'Get help'
  },
  partnerships: {
    id: 'partnerships',
    defaultMessage: 'Partnerships'
  },
  contactUs: {
    id: 'contactUs',
    defaultMessage: 'Contact us'
  },
  howToCancel: {
    id: 'howToCancel',
    defaultMessage: 'How to cancel'
  }
})
